<template>
    <div>
        <div class="content">
            <el-row type="flex" align="bottom" style="width: 1200px;margin: auto;">
                <el-col :span="12" align="left" style="height: 150px;">
                    <div class="title">关于我们</div>
                    <!--                <div class="text">了解中创远泰，了解行业前沿资讯</div>-->
                </el-col>
                <el-col :span="12" align="left">
                    <img class="img" src="../../assets/images/about.png"/>
                </el-col>
            </el-row>
        </div>
        <div class="detailsBox">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>关于我们</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row style="padding-top: 50px;">
                <el-col :span="10">
                    <div style="margin-top: 80px;text-indent:2em;letter-spacing:3px;line-height: 30px;text-align: left;">
                        <p>天津中创远泰物流有限公司作为中创物流股份有限公司全资控股的子公司，注册资本5000万元，落户于天津东疆保税港区，主要经营国内货物道路运输以及网络货运平台研发、运营等相关服务。</p>
                        <p>依托中创物流网络覆盖，以集装箱业务为基础，利用信息化技术，减少中间环节，简化操作流程，实现货主、场站、码头、司机直联，确保物流节点更加透明，运输更加安全高效。</p>
                    </div>
                </el-col>
                <el-col :span="14">
                    <div style="position: relative">
                        <div style="width: 200px;height: 200px;background: #31b98b;position: absolute;top: 0;right: 0;z-index: 1;"></div>
                        <img src="../../assets/images/about-4.png" style="width:500px;height:500px;position:absolute;z-index: 2;top: 50px;left: 150px;"/>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="about-company">
            <div class="company-box">
                <p class="title">企业文化</p>
                <p class="text">联动互动，整体依存，实现最大发展动力</p>
                <p class="text">严谨务实，优质高效，提供周到客服服务</p>
                <p class="text">宽厚宽容，和谐创新，追求至高社会责任</p>
            </div>
        </div>
        <div class="about-ccertify">
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide data-history="slide1">
                    <img src="../../assets/images/banner-certificate-1.png">
                    <p>计算机软件著作权认证</p>
                </swiper-slide>
                <swiper-slide data-history="slide2">
                    <img src="../../assets/images/banner-certificate-2.png">
                    <p>企业营业执照</p>
                </swiper-slide>
                <swiper-slide data-history="slide3">
                    <img src="../../assets/images/banner-certificate-3.png">
                    <p>道路运输经营许可证书</p>
                </swiper-slide>
            </swiper>
        </div>
        <div class="about-contact">
            <div class="contact-box">
                <div class="contact-title">联系我们</div>
                <el-row>
                    <el-col :span="10">
                        <p class="title">天津中创远泰物流有限公司</p>
                        <p class="text">业务部电话：刘经理 13820351987      liuhaitao@cmlog.com</p>
                        <p class="text">客服部电话：张经理 15522308879      zhanglei-ec@cmlog.com</p>
                        <p class="text">行财务电话：牟主管 15022770118      mujian@cmlog.com</p>
                        <p class="text">总负责人： 杨经理18622598201      yangwei@cmlog.com</p>
                    </el-col>
                    <el-col :span="14">
                        <amap style="height: 300px;width: 100%;" :center="[117.754535, 39.017266]" :zoom="12">
                            <amap-marker :position="[117.754535, 39.017266]" :icon="markerIcon"
                                         :label="{content: '天津市滨海新区天津港保税区京门大道242号',direction: 'bottom'}">
                            </amap-marker>
                        </amap>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import markerIcon from '../../assets/images/marker.svg'
import {swiper, swiperSlide} from 'vue-awesome-swiper'

export default {
    name: 'About',
    components: {
        swiper,
        swiperSlide
    },
    data () {
        return {
            markerIcon,
            visible: false,
            position: null,
            swiperOption: {
                loop: true,
                // slidesPerView: 3,
                // centeredSlidesBounds: true,
                watchSlidesProgress: true,
                slidesPerView: 'auto',
                centeredSlides: true,
                loopedSlides: 3,
                autoplay: {
                    delay: 3000
                },
                // 显示分页
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true // 允许分页点击跳转
                },
                on: {
                    progress: function (progress) {
                        for (let i = 0; i < this.slides.length; i++) {
                            let slide = this.slides.eq(i)
                            let slideProgress = this.slides[i].progress
                            let modify = 1
                            if (Math.abs(slideProgress) > 1) {
                                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1
                            }
                            let translate = slideProgress * modify * 260 + 'px'
                            let scale = 1 - Math.abs(slideProgress) / 5
                            let zIndex = 999 - Math.abs(Math.round(10 * slideProgress))
                            slide.transform('translateX(' + translate + ') scale(' + scale + ')')
                            slide.css('zIndex', zIndex)
                            slide.css('opacity', 1)
                            if (Math.abs(slideProgress) > 3) {
                                slide.css('opacity', 0)
                            }
                        }
                    },
                    setTransition: function (transition) {
                        for (let i = 0; i < this.slides.length; i++) {
                            let slide = this.slides.eq(i)
                            slide.transition(transition)
                        }
                    }
                }
            }
        }
    }
}
</script>
<style>
.about-ccertify {
    padding-top: 100px;
    position: relative;
    width: 1200px;
    margin: 0 auto
}

.about-ccertify .swiper-container {
    padding-bottom: 60px;
}

.about-ccertify  .swiper-slide {
    width: 520px;
    height: 408px;
    background: #fff;
    box-shadow: 0 8px 30px #ddd;
}
.about-ccertify  .swiper-slide img{
    width: 100%;
    display:block;
}
.about-ccertify  .swiper-slide p {
    line-height: 98px;
    padding-top: 0;
    text-align: center;
    color: #636363;
    font-size: 1.1em;
    margin: 0;
}

.about-ccertify .swiper-pagination {
    width: 100%;
    bottom: 20px;
}

.about-ccertify .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 5px;
    border: 3px solid #fff;
    background-color: #d5d5d5;
    width: 10px;
    height: 10px;
    opacity: 1;
}

.about-ccertify .swiper-pagination-bullets .swiper-pagination-bullet-active {
    border: 3px solid #00aadc;
    background-color: #fff;
}

.about-ccertify .swiper-button-prev {
    left: -30px;
    width: 45px;
    height: 45px;
    /*background: url(../../assets/images/banner-1.png) no-repeat;*/
    /*background-position: 0 0;*/
    /*background-size: 100%;*/
}

.about-ccertify .swiper-button-prev:hover {
    background-position: 0 -46px;
    background-size: 100%
}

.about-ccertify .swiper-button-next {
    right: -30px;
    width: 45px;
    height: 45px;
    /*background: url(../../assets/images/about-5.png) no-repeat;*/
    /*background-position: 0 -93px;*/
    /*background-size: 100%;*/
}

.about-ccertify .swiper-button-next:hover {
    background-position: 0 -139px;
    background-size: 100%
}
</style>
<style lang="scss" scoped>
/deep/ .amap-icon{
    img{
        top: 0;
        left: 0;
    }
}
/deep/ .amap-marker-label{
    padding: 10px;
    border: 1px solid #e1e1e1;
    border-radius: 5px;
}
.content{
    padding-top: 90px;
    background-color: #31b98b;
    .title{
        font-size: 36px;
        color: #ffffff;
        font-weight: bold;
        line-height: 40px;
        font-style: italic;
    }
    .text{
        font-size: 24px;
        color: #ffffff;
        line-height: 40px;
        margin-top: 20px;
        font-weight: 300;
    }
    .img{
        display: block;
        width: 500px;
    }
}
.detailsBox {
    width: 1200px;
    margin: auto;
    padding: 30px 0;
}
.about-company{
    margin-top: 200px;
    background: url("../../assets/images/about-5.png") 100% 100%;
    height: 700px;
    .company-box{
        padding-top: 70px;
        text-align: center;
        color: #ffffff;
        .title{
            font-size: 56px;
            margin-bottom: 120px;
        }
        .text{
            font-size: 38px;
        }
    }
}
.about-contact{
    padding: 100px 0;
    .contact-box{
        width: 1200px;
        margin: auto;
        .contact-title{
            font-size: 38px;
            color: #333333;
            text-align: center;
            margin-bottom: 100px;
        }
        .title{
            text-align: left;
            font-size: 24px;
            font-weight: bold;
            color: #333333;
        }
        .text{
            text-align: left;
            font-size: 14px;
            color: #333333;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/about/index.vue